export { default } from './DiagnosticStatistic';
